import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from '../../common/axios-common';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import ResultStatusCode from '../../common/code/ResultStatusCode';

interface Props {
  supplier: string;
  // validate有無
  isValidate?: boolean;
  disabled?: boolean;
}

interface SupplierSelect {
  label: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierSelects',
  props: {
    supplier: {},
    isValidate: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  emits: ['selectSupplier'],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const router = useRouter();
const emit = __emit;

// プルダウン
const options = ref<SupplierSelect[]>([]);
// プルダウン（フィルター用）
const filterOptions = ref(options.value);
// Loading
const isLoading = ref(false);

// サプライヤ選択値
const selectSupplier = computed({
  get: () => props.supplier,
  set: (value) => {
    emit('selectSupplier', value || '');
  },
});

/**
 * サプライヤリスト取得
 */
const getSupplier = () => {
  // Loading Start
  isLoading.value = true;

  axios
    .post('/suppliers')
    .then((res) => {
      const { common, supplierSelectItems } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          supplierSelectItems.forEach(
            (supplier: { supplier_name: string; supplier_code: string }) => {
              options.value.push({
                label: `${supplier.supplier_code}: ${supplier.supplier_name}`,
                value: supplier.supplier_code,
              });
            }
          );
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.response.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      isLoading.value = false;
    });
};
// プルダウンフィルター
const filterFn = (val: string, update: (arg0: () => void) => void) => {
  update(() => {
    if (val === '') {
      filterOptions.value = options.value;
    } else {
      const needle = val.toLowerCase();
      filterOptions.value = options.value.filter(
        (v: { label: string; value: string }) =>
          v.label.toLowerCase().indexOf(needle) > -1 || v.value.toLowerCase().indexOf(needle) > -1
      );
    }
  });
};

/**
 * 初期表示処理
 */
getSupplier();

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createBlock(_component_q_select, _mergeProps({
    modelValue: selectSupplier.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectSupplier).value = $event)),
    options: filterOptions.value,
    outlined: "",
    dense: "",
    clearable: "",
    "emit-value": "",
    "use-input": "",
    "map-options": "",
    disable: props.disabled,
    loading: isLoading.value
  }, !selectSupplier.value && { placeholder: '選択してください' }, {
    style: {"background":"var(--q-white)","padding":"0"},
    rules: props.isValidate ? [(val) => !!val || _ctx.$t('validation.required')] : undefined,
    onFilter: filterFn
  }), {
    "no-option": _withCtx(() => [
      _createVNode(_component_q_item, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_item_section, { class: "text-grey" }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("該当するサプライヤはありません")
            ])),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["modelValue", "options", "disable", "loading", "rules"]))
}
}

})